import { AuthState, FirebaseUser, FirebaseError } from './state'
import { Driver } from '../../types/driver'

type Action =
	| { type: 'LOGIN_STARTED' }
	| { type: 'LOGIN_FINISHED' }
	| { type: 'GET_FIREBASE_USER_STARTED' }
	| { type: 'GET_FIREBASE_USER_FINISHED'; currentFirebaseUser?: FirebaseUser }
	| { type: 'FIND_DRIVER_STARTED' }
	| { type: 'FIND_DRIVER_FINISHED'; currentDriver?: Driver }
	| { type: 'LOGOUT' }
	| { type: 'ERROR'; error?: FirebaseError }

/**
 * Handles how that state changes in the `useAuth` hook.
 */
export const reducer = (state: AuthState, action: Action): AuthState => {
	switch (action.type) {
		case 'LOGIN_STARTED':
			return {
				...state,
				isLoading: true,
				error: undefined,
			}
		case 'LOGIN_FINISHED':
			return {
				...state,
				isLoading: false,
				error: undefined,
			}
		case 'GET_FIREBASE_USER_STARTED':
			return {
				...state,
				isLoading: true,
			}
		case 'GET_FIREBASE_USER_FINISHED':
			return {
				...state,
				currentFirebaseUser: action.currentFirebaseUser,
				isLoading: false,
			}
		case 'FIND_DRIVER_STARTED':
			return {
				...state,
				isLoading: true,
			}
		case 'FIND_DRIVER_FINISHED':
			return {
				...state,
				currentDriver: action.currentDriver,
				isAuthenticated: !!action.currentDriver,
				isLoading: false,
			}
		case 'LOGOUT':
			return {
				...state,
				isAuthenticated: false,
				currentFirebaseUser: undefined,
			}
		case 'ERROR':
			return {
				...state,
				isLoading: false,
				error: action.error,
			}
	}
}
